import { ChevronsUpDown } from "lucide-react";
import React, { ReactNode } from "react";

interface Column {
  header: string;
  key: string;
  width?: string;
  onClick?: () => void;
  sortDirection?: "asc" | "desc" | null;
}

interface OrdersTableProps {
  columns: Column[];
  children: ReactNode;
  emptyMessage: string;
}

export default function OrdersTable({
  columns,
  children,
  emptyMessage,
}: OrdersTableProps) {
  const hasContent = React.Children.count(children) > 0;

  return (
    <div className="bg-white rounded-lg overflow-x-auto">
      <table className="min-w-full">
        <thead className="bg-gray-50">
          <tr className="rounded-xl overflow-hidden">
            {columns.map((column, index) => (
              <th
                key={column.key}
                className={`
                  px-6 py-3 
                  text-left text-xs font-medium text-gray-500 tracking-wider 
                  ${column.width || ""} 
                  ${index === 0 ? "rounded-l-xl" : ""} 
                  ${index === columns.length - 1 ? "rounded-r-xl" : ""}
                `}
              >
                <span className="flex items-center gap-0">
                  {column.header}
                  {column.onClick && (
                    <div
                      className="cursor-pointer p-1"
                      onClick={column.onClick}
                    >
                      <ChevronsUpDown className="w-4 h-4" />
                    </div>
                  )}
                </span>
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-white">
          {React.Children.map(children, (child, index) => {
            if (React.isValidElement<any>(child)) {
              return React.cloneElement(child, {
                ...child.props,
                className: `${child.props.className || ""} ${
                  index === 0 ? "border-t-0" : ""
                } border-b border-gray-200`,
              });
            }
            return child;
          })}
        </tbody>
      </table>

      {!hasContent && (
        <div className="text-center py-16">
          <div className="text-gray-400 text-lg mb-2">📦</div>
          <div className="text-gray-500 text-base font-medium mb-1">
            {emptyMessage}
          </div>
          <div className="text-gray-400 text-sm">
            Los pedidos aparecerán aquí cuando estén disponibles
          </div>
        </div>
      )}
    </div>
  );
}
